import type { ColumnDef } from "@tanstack/react-table";

import { DRIVER_ACTION_WORKING } from "@storyboard/dispatch-view/fieldKinds";
import { DriverActionCell } from "@/components/Dispatch/DriverActionCell";
import { driverActionsFor } from "@/hooks/dispatch/driverActions";
import type { DriverRow } from "@/types/driver";
import ColumnHeader from "@/ui/ColumnHeader";
import type { DataTableFeatures } from "@/ui/dataTableFeatures";
import type { ColumnFilterOptions } from ".";
import { columnWidthFloors } from "./columnMinWidth";

const DRIVER_ACTION_COLUMN_TITLE = "Driver Action";

/**
 * The legacy driver table's Driver Action column: the same pill and hover card as the Dispatch view's, with the
 * actions derived per row from the never-logged-in set and the device usage the view already polls.
 */
export function driverActionColumn(options: ColumnFilterOptions): ColumnDef<DataTableFeatures, DriverRow> {
  const { minSize, initialMinWidth } = columnWidthFloors(DRIVER_ACTION_COLUMN_TITLE, {
    draggable: true,
    hasFilter: false,
  });
  return {
    id: "driverAction",
    header: () => <ColumnHeader title={DRIVER_ACTION_COLUMN_TITLE} />,
    cell: ({ row }) => {
      const membershipId = row.original.workspaceMembershipId;
      const actions = driverActionsFor(row.original, {
        neverLoggedIn: options.unactivatedMembershipIds?.has(membershipId) ?? false,
        personalDeviceOnly: options.personalOnlyMembershipIds?.has(membershipId) ?? false,
      });
      return <DriverActionCell value={actions[0] ?? DRIVER_ACTION_WORKING} actions={actions} context={row.original} />;
    },
    meta: { flex: 1.5, draggable: true, initialMinWidth },
    minSize,
    enableSorting: false,
    enableGlobalFilter: false,
  };
}
